import {
  FETCH_SPARE_INVENTORY_FILTER,
  FETCH_SPARE_INVENTORY_SUCCESS,
  RESET_SPARE_INVENTORY,
  SPARE_PART_BALANCE_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  datas: [],
  locations: [],
  subLocations: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_SPARE_INVENTORY_SUCCESS: {
      return {
        ...state,
        // total: action.count,
        datas: action.inventories,
        // resource: action.inventories,
        // pageNo: action.page
      };
    }
    case FETCH_SPARE_INVENTORY_FILTER: {
      return {
        ...state,
        locations: action.locations,
        subLocations: action.subLocations,
        // spareParts: action.spareParts,
        sparePartTypes: action.sparePartTypes,
      };
    }
    case RESET_SPARE_INVENTORY: {
      return {
        ...state,
        datas: [],
      }
    }
    case SPARE_PART_BALANCE_SUCCESS: {
      return {
        ...state,
        balance: action.balance
      }
    }
    default:
      return state;
  }
};
